export const isFirstLetterD = (letter: string) => {
  if (letter.startsWith('D')) {
    return true;
  }
  return false;
};
